export const compareByKeys = (o1, o2) => {
  const flatten = (obj, map = {}) => {
    if (!obj) return map;
    for (const [k, v] of Object.entries(obj)) {
      map[k] = v;
      if (v && typeof v === "object") flatten(v, map);
    }
    return map;
  };

  const a = flatten(o1);
  const b = flatten(o2);

  return [...new Set([...Object.keys(a), ...Object.keys(b)])]
    .filter((k) => !(a[k] == null && b[k] == null))
    .filter((k) => JSON.stringify(a[k]) !== JSON.stringify(b[k]))
    .map((k) => ({ key: k, obj1: a[k], obj2: b[k] }));
};
